const permissionsEN = {
  // namespace your translation keys with "prm", i.e.
  // 'prm.lorem_ipsum': 'Lorem Ipsum'
}

export default permissionsEN
